(() => {
  if (window.apexNavigationReady) return;
  window.apexNavigationReady = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.apex-mobile-menu a');
    if (link) link.closest('details').open = false;
    const comparisonLink = event.target.closest('.apex-place-link[href="#comparatif"]');
    if (!comparisonLink || !window.matchMedia('(max-width: 760px)').matches || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const comparison = document.getElementById('comparatif');
    if (!comparison) return;
    event.preventDefault();
    const header = document.querySelector('.apex-header-shell');
    const offset = (header?.getBoundingClientRect().height || 0) + 16;
    const top = window.scrollY + comparison.getBoundingClientRect().top - offset;
    const heading = comparison.querySelector('h2');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus({preventScroll: true});
    }
    if (window.location.hash !== '#comparatif') window.history.pushState(null, '', '#comparatif');
    window.scrollTo({top: Math.max(0, top), behavior: 'instant'});
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('.apex-mobile[open]');
    if (menu) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
})();
